<template>
  <div>
    <label>FV Zlecenia głównego:</label>
    <div class="address-data-container col-xs-12 list-group"
         :key="`main-invoice-${mainInvoiceIndex}`"
         v-for="(mainInvoice, mainInvoiceIndex) in mainInvoicesData"
    >
      <div class="list-group-item list-group-item-overflowed">
        <p><label>Numer fv dla Klienta: </label> {{ mainInvoice.invoiceNumber ?  mainInvoice.invoiceNumber : 'b.d'}}</p>
        <p><label>Data wystawienia fv dla Klienta: </label> {{ mainInvoice.date ? m$formatDate(mainInvoice.date, 'YYYY-MM-DD') : 'b.d'}}</p>
     <ul class="main-invoice-data__amounts">
          <li><label>Kwota: </label> {{mainInvoice.amount ? mainInvoice.amount : 'b.d' }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import formatDateMixin from '../../../../../share/mixins/formatDateMixin.js'

export default {
  name: 'InvoicesMain',
  props: {
    mainInvoicesData: {}
  },
  mixins: [formatDateMixin],
}
</script>

<style scoped>
.list-group-item-overflowed {
  overflow: hidden;
  text-overflow: ellipsis;
}
.main-invoice-data__amounts li:first-child{
  margin-left: -25px;
  list-style-type: circle;
}
.main-invoice-data__amounts li:nth-child(2), li:nth-child(3),li:nth-child(4), li:nth-child(5) {
  list-style-type: square;
}
</style>
